export const ceruleanCategoricalDefault: string[] = [];
export const ceruleanCategoricalMixed: string[] = [];
